<div class="col-12  mt-4 mb-2 d-flex justify-content-center align-items-center">
  <mat-progress-spinner class="example-margin" color="accent" mode="indeterminate"></mat-progress-spinner>
</div>